module.exports = __webpack_public_path__ + "img/20240901_2.a5432926.jpg";